var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeveral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 5,
    viewBox: "0 0 15 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2.5C14.5 3.625 13.5938 4.5 12.5 4.5C11.375 4.5 10.5 3.625 10.5 2.5C10.5 1.40625 11.375 0.5 12.5 0.5C13.5938 0.5 14.5 1.40625 14.5 2.5ZM12.5 1.75C12.0625 1.75 11.75 2.09375 11.75 2.5C11.75 2.9375 12.0625 3.25 12.5 3.25C12.9062 3.25 13.25 2.9375 13.25 2.5C13.25 2.09375 12.9062 1.75 12.5 1.75ZM9.5 2.5C9.5 3.625 8.59375 4.5 7.5 4.5C6.375 4.5 5.5 3.625 5.5 2.5C5.5 1.40625 6.375 0.5 7.5 0.5C8.59375 0.5 9.5 1.40625 9.5 2.5ZM7.5 1.75C7.0625 1.75 6.75 2.09375 6.75 2.5C6.75 2.9375 7.0625 3.25 7.5 3.25C7.90625 3.25 8.25 2.9375 8.25 2.5C8.25 2.09375 7.90625 1.75 7.5 1.75ZM0.5 2.5C0.5 1.40625 1.375 0.5 2.5 0.5C3.59375 0.5 4.5 1.40625 4.5 2.5C4.5 3.625 3.59375 4.5 2.5 4.5C1.375 4.5 0.5 3.625 0.5 2.5ZM2.5 3.25C2.90625 3.25 3.25 2.9375 3.25 2.5C3.25 2.09375 2.90625 1.75 2.5 1.75C2.0625 1.75 1.75 2.09375 1.75 2.5C1.75 2.9375 2.0625 3.25 2.5 3.25Z",
    fill: "#030303"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeveral);
export default __webpack_public_path__ + "static/media/several.93838a991a50125fc783a90ec21c09c2.svg";
export { ForwardRef as ReactComponent };